import { createFiltersReducer } from '../utils';
import { ACTIONS_PREFIX } from '../actions/mobileDevicesFilters';

const initialFiltersState = {
    searchData: '',
    users: [],
    offices: [],
    resourceOwner: [],
    strict: false,
    officeState: 2,
    resourceOwnerState: 2,
    isDismissedEmployees: null,
    resourceOwnerStrict: false,
    osVersions: [],
    screens: [],
    projects: [],
    deviceTypes: [],
    ids: [],
    assignmentDateFrom: null,
    assignmentDateTo: null,
    deliveryDateFrom: null,
    deliveryDateTo: null,
    isPrimary: null,
    condition: {
        working: false,
        nonWorking: false,
        workingConditionally: false
    },
    state: {
        inUse: false,
        onStock: false,
        underRepair: false
    },
    primary: {
        yes: false,
        no: false
    },
    pageNumber: 1,
    sortBy: 'mobileDeviceTypeName',
    sortOrder: 'asc',
    rangeOSVersion: {
        isRanged: false,
        osVersion: null,
    },
    isAppliedFilter: false
};

const initialState = {
    currentFilters: {
        ...initialFiltersState
    },
    appliedFilters: {
        ...initialFiltersState
    }
};

const mobileDevicesFiltersReducer = createFiltersReducer(ACTIONS_PREFIX, initialState);
export default mobileDevicesFiltersReducer;
